module.exports = __webpack_public_path__ + "assets/img/warning.1c77e988.svg";